import { t } from '../../translations';
import type { Language } from '../../types';

/**
 * Подпись стола целиком из перевода, а не «слово + число».
 * В кыргызском и китайском номер стоит перед словом («5-стол», «5号桌»),
 * поэтому конкатенация давала кальку с русского.
 */
export function tableLabel(table: string | number | null | undefined, language: Language): string {
  return t('common.tableLabel', language).replace('{n}', String(table ?? '?'));
}
